module.exports = __webpack_public_path__ + "img/banner-fabrica.41cb478e.jpeg";